import React from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import AppHeader from './components/core/AppHeader.js';
import PhotoSelector from './components/photo_selector/PhotoSelector.js';
import EditOptions from './components/edit/EditOptions.js';
import Collage from './components/collage/Collage.js';
import { setMode, setActiveText, setTextPositioning, shuffle, unchoosePhoto, addToSwap, clickAway} from 'components/collage/CollageSlice.js'

// Firebase
import firebase from 'firebase/app';
import 'firebase/analytics';

// Components
import HologramMenu from 'components/misc/HologramMenu.js';
import TextInput from 'components/misc/text_input/TextInput.js';
import OverlaySpinner from 'components/misc/OverlaySpinner.js';
import TallBoyAd from 'components/misc/TallBoyAd.js';
import Modal from 'react-modal';

// Images
import TrashIcon from 'img/icons/trash.svg';
import SwapIcon from 'img/icons/swap.svg';

import './App.css';

class App extends React.Component {
  constructor(props) {
    super(props)
    
    this._initialPadding = {
      sm: 140,
      lg: 0
    }

    this._galleryOffsets = {
      sm: 500,
      lg: 620
    };

    this._actionHeights = {
      sm: 40,
      lg: 24
    }

    this.state = {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      canvasDimensions: {},
      canvasPadding: this.props.collage.mode == 'sm' ? (this._galleryOffsets.sm - this._initialPadding.sm) : this._galleryOffsets.lg,
      activelyExporting: false,
      exportStep: 0,
      tempCollage: null,
      isMobile: false
    }

    // Hardcoded amount to wait for a "render" during export
    this._renderWait = 1000;

  }

  componentDidMount() {
    
    const config = {
      apiKey: "AIzaSyBqwTfCoFCE-7heAKCNHV0XgbPzWEF0uX0",
      authDomain: "gandr-web.firebaseapp.com",
      projectId: "gandr-web",
      storageBucket: "gandr-web.appspot.com",
      messagingSenderId: "132723145768",
      appId: "1:132723145768:web:def9b938541d4ae13c891d",
      measurementId: "G-LFMD406GMV"
    };

    firebase.initializeApp(config);

    firebase.analytics();

    document.body.addEventListener('mouseup', (event) => {

      let editBar = document.getElementById('EditBar');
      let clickAwayArgs = {
        unhighlightText: false,
        removeActiveBlock: false,
        resetHologram: false
      };

      // If DIDN'T click something in the EditBar, then activeText can be un-highlighted
      if ( 
        editBar 
        && !editBar.contains(event.target) 
        // && this.props.collage.activeEditScreen == 'text_options' 
        && this.props.collage.activeText !== false 
        && document.getElementsByClassName('selected').length === 0 
        && ! event.target.classList.contains('ButtonTrash') 
      ) {
        clickAwayArgs.unhighlightText = true
      }

      // If DIDN'T click block, the active block can be made un-active
      if ( ! event.target.classList.contains('BlockButton') 
        && ! event.target.classList.contains('HologramOption') 
      ) {
        clickAwayArgs.removeActiveBlock = true;
      }

      // If DIDN'T click a hologram option, then hide the hologram menu
      if ( ! event.target.classList.contains('HologramOption') 
        && ! event.target.classList.contains('BlockButton') 
        && ! event.target.classList.contains('react-transform-element')
      ) {
        clickAwayArgs.resetHologram = true;
      }

      this.props.clickAway(clickAwayArgs);

    });

    
    // TextInput listener
    document.addEventListener('drrSelect', (event) => {
      if ( event.detail ) {
        this.props.setActiveText(event.target.dataset.index);
      }
    })
    
    // TextInput listener
    document.addEventListener('drrDidChange', (event) => {
      let cssSplit = event.target.style.cssText.split(';');
      let textPositioning = {
        width: event.target.offsetWidth,
        height: event.target.offsetHeight
      }

      for ( let c = 0; c < cssSplit.length; c++ ) {
        
        let attributeSplit  = cssSplit[c].split(':');

        if ( attributeSplit.length < 2 )
          continue;

        let attributeName   = attributeSplit[0].trim();
        let attributeValue  = attributeSplit[1].trim();

        switch(attributeName) {
          case '--left':
            textPositioning.left = attributeValue;
            break;
          case '--top':
            textPositioning.top = attributeValue;
            break;
          case '--rotate':
            textPositioning.rotate = attributeValue;
            break;
        }
        //console.log('value of "' + attributeSplit[0] + '" is "' + attributeSplit[1] + '"');
      }

      this.props.setTextPositioning(textPositioning);

    })
    
    this.setState({
      canvasDimensions: {
        width: document.getElementById('Canvas').offsetWidth,
        height: document.getElementById('Canvas').offsetHeight
      }
    });    

    window.addEventListener('resize', () => {

      this.props.setMode(window.innerWidth < 1024 ? 'sm' : 'lg');

      this.setState({
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        canvasPadding: window.innerWidth < 1024 ? this._galleryOffsets['sm'] : this._galleryOffsets['lg'],
        canvasDimensions: {
          width: document.getElementById('Canvas').offsetWidth,
          height: document.getElementById('Canvas').offsetHeight
        },
        dragX: 0,
        dragY: 0
      });
    });

    if ( window.innerWidth < 768 ) {
      this.setState({
        isMobile: true
      })
    }

  }

  componentDidUpdate(prevProps, prevState) {

    if ( this.state.exportStep > 0 ) {

      switch( this.state.exportStep ) {
        case 1:
          this.exportStep1();
          break;
        case 2:
          this.exportStep2();
          break;
        case 3:
          this.exportStep3();
          break;
        case 4:
          this.exportStep4();
          break;
      }

    }
    
  }

  handleDownloadClick = async () => {
    if ( Object.keys(this.props.collage.photos.chosenNodes).length ) {
      firebase.analytics().logEvent('save_collage', {
        num_photos: this.props.collage.photos.numChosen
      });
      this.setState({
        activelyExporting: true,
        exportStep: 1
      });
    }
  }

  /**
   * Scale up collage to full size and position off-screen
   */
  exportStep1 = () => {
    console.log('exportStep1');

    // Unhighlight any active UI elements
    this.props.clickAway({
      unhighlightText: true,
      removeActiveBlock: true,
      resetHologram: true
    });
    
    this.setState({
      exportStep: 2
    })

  }

  /**
   * Take temporary snapshot of the scaled collage to show while full-res is saved
   */
  exportStep2 = () => {
    console.log('exportStep2');
    // this.state.exportStep = 0;
    let tempCanvas = document.getElementById('temp-canvas');
    if ( tempCanvas ) {
      tempCanvas.remove();
    }

    window.html2canvas(
      document.getElementById("CollageUnscaled"),
      {
        foreignObjectRendering: false,
        allowTaint: true
      }
    ).then(canvas => {
      this.setState({
        exportStep: 3,
        tempCollage: canvas.toDataURL('image/jpeg')
      })
    });

  }

  /**
   * - Scale up collage to full size and position off-screen
   * - Take snapshot of collage at full width
   */
  exportStep3 = () => {
    console.log('exportStep3');

    // Explicitly set step to 0 year to prevent multiple downloads at once
    // ie. if the screen is resized during saving, the component will update and call this function again if the step is still 3
    this.state.exportStep = 4;

    setTimeout(() => {
      
      window.html2canvas(
        document.getElementById("Collage"),
        {
          scale: 1,
          foreignObjectRendering: false,
          allowTaint: true
        }
      ).then(canvas => {

        let exportLink = document.getElementById('export');
        exportLink.href = canvas.toDataURL('image/jpeg');
        exportLink.click(); // triggers download

        this.setState({
          exportStep: 4
        })

      });

    }, this._renderWait);
    
  }

  /**
   * - Set step back to 0 and keep transition animations off until temp collage is removed
   */
  exportStep4 = () => {
    this.setState({
      exportStep: 0
    });
    setTimeout(() => {
      this.setState({
        activelyExporting: false
      });
    }, this._renderWait)
  }

  handleDrag = (e, data) => {

    if ( this.props.collage.mode == 'sm' ) {
      this.setState({
        canvasPadding: this._galleryOffsets[this.props.collage.mode] - data.y,
        canvasDimensions: {
          width: document.getElementById('Canvas').offsetWidth,
          height: document.getElementById('Canvas').offsetHeight
        },
      })
    }
    else {
      this.setState({
        canvasPadding: this._galleryOffsets[this.props.collage.mode] - data.x,
        canvasDimensions: {
          width: document.getElementById('Canvas').offsetWidth,
          height: document.getElementById('Canvas').offsetHeight
        },
      })
    }

  }

  render() {
    console.log(this.props.collage.resolution.ratio.name);
    let canvasStyle       = {};
    let appClassName      = ['App']
    let canvasClassName   = 'Canvas Canvas--' + (this.props.collage.resolution.ratio.isPortrait ? 'Portrait' : 'Landscape');
    
    if ( this.props.collage.mode == 'sm' ) {
      canvasStyle = {paddingBottom: this.state.canvasPadding};
    }
    else {
      canvasStyle = {paddingRight: this.state.canvasPadding};
    }

    if ( this.state.activelyExporting ) {
      appClassName.push('App--Exporting');
    }

    if ( this.state.exportStep > 0 ) {
      appClassName.push('App--ExportStep' + this.state.exportStep);
    }

    appClassName.push('App--Mode-' + this.props.collage.mode);

    // Calculate scale of the collage 
    let scale = 1;

    if ( this.state.canvasDimensions.width ) {
      let percentDiffWidth  = false;
      let percentDiffHeight = false;

      // 708 / 1920 = 0.36875
      if ( this.props.collage.resolution.width > this.state.canvasDimensions.width ) {
        percentDiffWidth = this.state.canvasDimensions.width / this.props.collage.resolution.width;
      }
      // 486 / 1920 = 0.253125
      if ( this.props.collage.resolution.height > this.state.canvasDimensions.height ) {
        percentDiffHeight = (this.state.canvasDimensions.height / this.props.collage.resolution.height);
      }
  
      if ( percentDiffWidth || percentDiffHeight ) {
        let percentDiff;
        if ( percentDiffWidth && percentDiffHeight ) {
          percentDiff = percentDiffWidth < percentDiffHeight ? percentDiffWidth : percentDiffHeight;
        }
        else {
          percentDiff = percentDiffWidth ? percentDiffWidth : percentDiffHeight;
        }
        scale = percentDiff * 0.96
      }
    }

    let showTallBoys = false;
    // switch( this.props.collage.resolution.ratio.name ) {
    //   case '1:1':
    //     case '1:2':
    //       case '3:4':
    //         case '4:5':
    //           case '5:7':
    //             case '9:16':
    //     showTallBoys = true;
    // }

    return (
      <div className={appClassName.join(' ')} id="App">
        <div className="BarTop">
          <AppHeader 
            onDownloadClick={this.handleDownloadClick}
          />
        </div>
        <div className="AppMain">
          <div 
            className="Nav1Wrap"
            key={this.state.windowWidth + 'X' + this.state.windowHeight} 
          >
            <Draggable
              axis={this.props.collage.mode == 'sm'  ? 'y' : 'x'}
              handle=".DividerDrag"
              defaultPosition={{x: 0, y: this.props.collage.mode == 'sm' ? this._initialPadding.sm : 0}}
              position={null}
              grid={[1, 1]}
              scale={1}
              bounds={
                this.props.collage.mode == 'sm' 
                  ? {top: 0, bottom: 440} 
                  : {left: 0, right: 560}
              }
              onStart={this.handleStart}
              onDrag={this.handleDrag}
              onStop={this.handleStop}
            >
              <div className="Nav1">
                <PhotoSelector />
              </div>
            </Draggable>
          </div>
          
          <div 
            className={canvasClassName} 
            style={canvasStyle}
          >
            <div className="CanvasInner" id="Canvas">
              
              {(showTallBoys) &&
                <TallBoyAd side="Left" />
              }

              <div 
                id="CollageUnscaled"
                className="CollageUnscaledZone" 
                style={{
                  width: this.props.collage.resolution.width * scale,
                  height: this.props.collage.resolution.height * scale
                }}
              >

                <Collage 
                  scale={scale} 
                  exportStep={this.state.exportStep}
                />

                {(this.state.exportStep == 3 || this.state.exportStep == 4) &&
                  <img 
                    className={'TempCollage'}
                    src={this.state.tempCollage} 
                    style={{
                      width: this.props.collage.resolution.width * scale,
                      height: this.props.collage.resolution.height * scale
                    }}
                  />
                } 
              
                {this.props.collage.texts.map((value, index) => {
                  return <TextInput index={index} />
                })}
              </div>
              
              {(showTallBoys) &&
                <TallBoyAd side="Right" />
              }

            </div>
          </div>
          <div className="Nav2">
            <EditOptions 
              onSizeChange={() => this.setState({
                canvasDimensions: {
                  width: document.getElementById('Canvas').offsetWidth,
                  height: document.getElementById('Canvas').offsetHeight
                }
              })}
            />
          </div>
        </div>

        {this.props.collage.hologramPosition &&
          <HologramMenu 
            options={[
              {
                name: 'Remove',
                icon: TrashIcon,
                onClick: () => this.props.unchoosePhoto(this.props.collage.activeBlock)
              },
              {
                name: 'Swap',
                icon: SwapIcon,
                onClick: () => this.props.addToSwap(this.props.collage.activeBlock)
              }
            ]}
          />
        }

        {this.state.activelyExporting &&
          <OverlaySpinner 
            loadText={'Generating your collage...'}
          />
        }

          <Modal
            isOpen={this.state.isMobile}
            style={{
              overlay: {
                background: 'rgba(255, 255, 255, 0.85)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 99
              },
              content: {
                background: '#1e1e1e',
                position: 'relative',
                width: 350,
                height: 500,
                inset: 0,
                padding: 30,
                boxSizing: 'border-box'
              }
            }}
          >
            <div className="MobileModal">
              <p>While you can use this collage maker (gandr.io) in your web browser, our mobile app offers the same features but built specifically for mobile.</p>
              <p>You may have a smoother experience using our 4.5 star mobile app.</p>
              <div className="MobileActions">
                <a href="https://play.google.com/store/apps/details?id=app.gandr&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1" class="Button ButtonReset">Open Google Play</a>
                <a href="https://itunes.apple.com/us/app/gandr/id1401102974?ls=1&mt=8" class="Button ButtonReset">Open App Store</a>
                <button href="" class="Button Button--Cancel ButtonReset" onClick={() => this.setState({isMobile: false})}>Cancel</button>
              </div>
            </div>
          </Modal>

      </div>
    )
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  {setMode, setActiveText, setTextPositioning, shuffle, unchoosePhoto, addToSwap, clickAway}
)(App)